// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"636":"d701630c","1519":"3b17df63","1956":"cb9706ad","2480":"cb9706ad"}[chunkId] + ".chunk.css";
};